// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"49":"db7bd921","277":"ccbf149f","435":"299c9087","707":"3ed40f77","766":"c8666a9f","839":"40a97126","872":"93c6936d"}[chunkId] + ".chunk.css";
};